// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-48e57f0a] img{display:block;margin:1rem 0}[data-v-48e57f0a] .related-collections.container{padding:0}[data-v-48e57f0a] .related-collections .badge-pill{margin-top:.25rem;margin-right:.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
